import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, TouchableOpacity, Platform } from 'react-native';
import { postSingle, Flex, Padding, Margin, Typo, article, postActionBar, articleItemHorizontal, FontFamily, articleLists } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';

import { helpers } from '../../utils/helpers';
import getImagePath from '../../utils/image-helper';
import CustomImage from '../custom-image';
import PremiumTag from '../premium-tag';

const teamOne = getImagePath('img/teamBannerOne.png');
const authorProfile = getImagePath('img/pranav-profile.jpg');

export class ArticleSpecificIndexStories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seeSecondAuthor: false
        }
    }

    componentDidMount = () => {
    }
    handleClick = () => {
        if (this.props.handleClick) {
            this.props.handleClick(this.props.data.title);
        }
    }

    clickCall = (data, btnClick) => {
        console.log('called', data);
        if (helpers.isWeb()) {
            btnClick = {
                to: "/category/" + data.category.slug
            }
        } else {
            btnClick = {
                onPress: () => this.viewCategory(data.category.slug)
            }
        }
        return btnClick
    }

    render() {

        const { data, darkMode, writers, home } = this.props;
        let { seeSecondAuthor } = this.state
        let btnClick, authorBtnClick, author2BtnClick, btnClickBookmark, btnClickLike;

        return (

            <View>
                {/* for 1 story */}
                {data && data.slice(0, 1).map((item, idx) => {

                    let btnClick, authorBtnClick, author2BtnClick, btnClickBookmark, btnClickLike;
                    if (helpers.isWeb()) {
                        btnClick = {
                            to: {
                                pathname: "/" + item.category.slug + "/" + item.slug,
                                postData: item
                            }
                        }
                        authorBtnClick = {
                            to: "/writers/" + item.author[0].slug
                        }
                        if (item.author[1]) {
                            author2BtnClick = {
                                to: "/writers/" + item.author[1].slug
                            }
                        }

                    } else {
                        btnClick = {
                            onPress: () => viewArticle(item.category.slug, item.slug, item)
                        }
                        authorBtnClick = {
                            onPress: (event) => {
                                event.stopPropagation();
                                viewAuthor(item.author[0].slug)
                            }
                        }
                        if (item.author[1]) {
                            author2BtnClick = {
                                onPress: (event) => {
                                    event.stopPropagation();
                                    viewAuthor(item.author[1].slug)
                                }
                            }
                        }
                        btnClickBookmark = {
                            onPress: (event) => {
                                event.stopPropagation();
                                applyStoryActions(Number(item.id), "bookmark", (item.user_story_action && item.user_story_action.bookmark) ? false : true)
                            }
                        }
                        btnClickLike = {
                            onPress: (event) => {
                                event.stopPropagation();
                                applyStoryActions(Number(item.id), "like", (item.user_story_action && item.user_story_action.like) ? false : true)
                            }
                        }
                    }
                    let btnCategoryClick = {
                        to: "/category/" + item.category.slug,
                    };
                    return (
                        <TouchableOpacityLink
                            {...btnClick}>
                            <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.FlexWrap, { width: "100%", padding: 15, marginBottom: 15 }]}>
                                <View style={[{ maxWidth: helpers.isDesktop() ? "46%" : "100%", width: "100%", marginBottom: 15 }]}>
                                    <CustomImage
                                        source={item?.featured_image?.url}
                                        require={true}
                                        resizeMode={'cover'}
                                        style={{ width: "100%", maxWidth: "100%", height: "auto" }}
                                        webStyle={{maxWidth:"100%", height:500, objectFit: "cover",
                                        margin: 0}}
                                        resizeMode="stretch"
                                    />
                                    {!item.is_free && <PremiumTag />}
                                </View>

                                <View style={[{ maxWidth: helpers.isDesktop() ? "54%" : "100%", paddingLeft: helpers.isDesktop() ? 20 : 0, paddingRight: helpers.isDesktop() ? 20 : 0 }]}>
                                    <TouchableOpacityLink {...btnCategoryClick}>
                                        <Text style={[{
                                            width: 150, marginBottom: helpers.isDesktop() ? 15 : 10, textAlign: "left", textTransform: "uppercase", fontFamily: "Matteo", fontStyle: "normal",
                                            fontWeight: "600",
                                            color:
                                                item.category.name === 'Business' ? "#2CB680" :
                                                    item.category.name === 'Chaos' ? "#907cff" :
                                                        item.category.name === 'Internet' ? "#FC876D" : "#ECB731"
                                            , fontSize: helpers.isDesktop() ? 19 : 13, lineHeight: helpers.isDesktop() ? 22.8 : 16, letterSpacing: helpers.isDesktop() ? 1 : 0.5,
                                        }, !helpers.isWeb() && { fontFamily: FontFamily.semiBold }, darkMode && { color: "#5263F4" }]}>
                                            {item.category.name}
                                        </Text>
                                    </TouchableOpacityLink>

                                    <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 30 : 16, lineHeight: helpers.isDesktop() ? 39 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { marginBottom: 15, fontFamily: FontFamily.abrilFatface }]}>
                                        {item.title}
                                    </Text>
                                    <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 27 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>
                                        {item.strapline}
                                    </Text>


                                    <View style={{ width: 100, height: 2, backgroundColor: "#907CFF", marginTop: 45, marginBottom: 18 }}></View>
                                    <View style={[Flex.row, Flex.alignCenter, { width: "100%", flexWrap: "wrap" }]}>

                                        <TouchableOpacityLink
                                            {...authorBtnClick}>
                                            <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                    <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                        <CustomImage
                                                            source={item.author[0].profile_image}
                                                            require={true}
                                                        />
                                                    </View>
                                                </View>
                                                <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>
                                                    {item.author[0].name}
                                                </Text>


                                            </View>
                                        </TouchableOpacityLink>

                                        {seeSecondAuthor && item.author[1] &&
                                            <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                    <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                        <CustomImage
                                                            source={item.author[1].profile_image}
                                                            require={true}
                                                        />
                                                    </View>
                                                </View>
                                                <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>{item.author[1].name}</Text>
                                            </View>}

                                        {item.author.length > 1 && !seeSecondAuthor &&
                                            <TouchableOpacity onPress={() => this.setState({ seeSecondAuthor: true })}>
                                                <View style={[{ borderStyle: "solid", fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22, borderWidth: 1, backgroundColor: "#F3F5FF", borderColor: "#907CFF", width: 28, height: 28, borderRadius: 28 }, Flex.alignCenter, Flex.row, Flex.justfiyCenter]}>+1</View>
                                            </TouchableOpacity>
                                        }
                                    </View>

                                </View>

                            </View>
                        </TouchableOpacityLink>
                    )
                })
                }
                {/* for 2 and 3 story */}
                {data && (data.length == 2 || data.length == 3) && data.slice(1, 4).map((item, idx) => {
                    let btnClick, authorBtnClick, author2BtnClick, btnClickBookmark, btnClickLike;
                    if (helpers.isWeb()) {
                        btnClick = {
                            to: {
                                pathname: "/" + item.category.slug + "/" + item.slug,
                                postData: item
                            }
                        }
                        authorBtnClick = {
                            to: "/writers/" + item.author[0].slug
                        }
                        if (item.author[1]) {
                            author2BtnClick = {
                                to: "/writers/" + item.author[1].slug
                            }
                        }

                    } else {
                        btnClick = {
                            onPress: () => viewArticle(item.category.slug, item.slug, item)
                        }
                        authorBtnClick = {
                            onPress: (event) => {
                                event.stopPropagation();
                                viewAuthor(item.author[0].slug)
                            }
                        }
                        if (item.author[1]) {
                            author2BtnClick = {
                                onPress: (event) => {
                                    event.stopPropagation();
                                    viewAuthor(item.author[1].slug)
                                }
                            }
                        }
                        btnClickBookmark = {
                            onPress: (event) => {
                                event.stopPropagation();
                                applyStoryActions(Number(item.id), "bookmark", (item.user_story_action && item.user_story_action.bookmark) ? false : true)
                            }
                        }
                        btnClickLike = {
                            onPress: (event) => {
                                event.stopPropagation();
                                applyStoryActions(Number(item.id), "like", (item.user_story_action && item.user_story_action.like) ? false : true)
                            }
                        }
                    }
                    let btnCategoryClick = {
                        to: "/category/" + item.category.slug,
                    };
                    return (<TouchableOpacityLink
                        {...btnClick}>
                        <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.FlexWrap, { width: "100%", padding: 15, marginBottom: 15 }]}>
                            <View style={[{ maxWidth: helpers.isDesktop() ? "35%" : "100%", width: "100%", marginBottom: 15 }]}>
                                <CustomImage
                                    source={item?.featured_image?.sizes['thumb']}
                                    require={true}
                                    resizeMode={'cover'}
                                    style={{ width: "100%", maxWidth: "100%", height: "auto" }}
                                />
                                {!item.is_free && <PremiumTag />}
                            </View>
                            <View style={[{ maxWidth: helpers.isDesktop() ? "65%" : "100%", paddingLeft: helpers.isDesktop() ? 20 : 0, paddingRight: helpers.isDesktop() ? 20 : 0 }]}>
                                <TouchableOpacityLink {...btnCategoryClick}>

                                    <Text style={[{
                                        width: 150, marginBottom: helpers.isDesktop() ? 15 : 10, textAlign: "left", textTransform: "uppercase", fontFamily: "Matteo", fontStyle: "normal",
                                        fontWeight: "600",
                                        color:
                                            item.category.name === 'Business' ? "#2CB680" :
                                                item.category.name === 'Chaos' ? "#907cff" :
                                                    item.category.name === 'Internet' ? "#FC876D" : "#ECB731"
                                        , fontSize: helpers.isDesktop() ? 19 : 13, lineHeight: helpers.isDesktop() ? 22.8 : 16, letterSpacing: helpers.isDesktop() ? 1 : 0.5,
                                    }, !helpers.isWeb() && { fontFamily: FontFamily.semiBold }, darkMode && { color: "#5263F4" }]}>
                                        {item.category.name}
                                    </Text>
                                </TouchableOpacityLink>
                                <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 30 : 16, lineHeight: helpers.isDesktop() ? 39 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { marginBottom: 15, fontFamily: FontFamily.abrilFatface }]}>{item.title}</Text>
                                <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 27 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>
                                    {item.strapline}
                                </Text>


                                <View style={{ width: 100, height: 2, backgroundColor: "#907CFF", marginTop: 10, marginBottom: 10 }}></View>
                                <View style={[Flex.row, Flex.alignCenter, { width: "100%", flexWrap: "wrap" }]}>
                                    <TouchableOpacityLink
                                        {...authorBtnClick}>

                                        <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                            <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                    <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                        <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                            <CustomImage
                                                                source={item.author[0].profile_image}
                                                                require={true}
                                                            />
                                                        </View>
                                                    </View>
                                                    <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>{item.author[0].name}</Text>


                                                </View>

                                                {seeSecondAuthor && item.author[1] &&
                                                    <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                        <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                            <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                                <CustomImage
                                                                    source={item.author[1].profile_image}
                                                                    require={true}
                                                                />
                                                            </View>
                                                        </View>
                                                        <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>{item.author[1].name}</Text>
                                                    </View>}

                                                {item.author.length > 1 && !seeSecondAuthor &&
                                                    <TouchableOpacity onPress={() => this.setState({ seeSecondAuthor: true })}>
                                                        <View style={[{ borderStyle: "solid", fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22, borderWidth: 1, backgroundColor: "#F3F5FF", borderColor: "#907CFF", width: 28, height: 28, borderRadius: 28 }, Flex.alignCenter, Flex.row, Flex.justfiyCenter]}>+1</View>
                                                    </TouchableOpacity>
                                                }
                                            </View>
                                        </View>
                                    </TouchableOpacityLink>
                                </View>

                            </View>
                        </View>

                    </TouchableOpacityLink>)
                })
                }



                {/* for 4 story */}
                <View style={[Flex.row, Flex.justifyStart, Flex.FlexWrap, { width: "100%" }]}>
                    {data && data.length == 4 && data.slice(1).map((item, idx) => {
                        let btnClick, authorBtnClick, author2BtnClick, btnClickBookmark, btnClickLike;
                        if (helpers.isWeb()) {
                            btnClick = {
                                to: {
                                    pathname: "/" + item.category.slug + "/" + item.slug,
                                    postData: item
                                }
                            }
                            authorBtnClick = {
                                to: "/writers/" + item.author[0].slug
                            }
                            if (item.author[1]) {
                                author2BtnClick = {
                                    to: "/writers/" + item.author[1].slug
                                }
                            }

                        } else {
                            btnClick = {
                                onPress: () => viewArticle(item.category.slug, item.slug, item)
                            }
                            authorBtnClick = {
                                onPress: (event) => {
                                    event.stopPropagation();
                                    viewAuthor(item.author[0].slug)
                                }
                            }
                            if (item.author[1]) {
                                author2BtnClick = {
                                    onPress: (event) => {
                                        event.stopPropagation();
                                        viewAuthor(item.author[1].slug)
                                    }
                                }
                            }
                        }
                        let btnCategoryClick = {
                            to: "/category/" + item.category.slug,
                        };

                        return (
                            <View style={[Flex.column, Flex.FlexWrap, { marginBottom: 15, padding: 15, width: helpers.isDesktop() ? "33%" : "100%" }]}>
                                <TouchableOpacityLink
                                    {...btnClick}>
                                    <View style={[{ maxWidth: helpers.isDesktop() ? "100%" : "100%", width: "100%", marginBottom: 15 }]}>
                                        <View style={{ marginBottom: helpers.isDesktop() ? 15 : 10 }}>
                                            <TouchableOpacityLink {...btnCategoryClick}>
                                                <Text style={[{
                                                    width: 150, textAlign: "left", textTransform: "uppercase", fontFamily: "Matteo", fontStyle: "normal",
                                                    fontWeight: "600",
                                                    color:
                                                        item.category.name === 'Business' ? "#2CB680" :
                                                            item.category.name === 'Chaos' ? "#907cff" :
                                                                item.category.name === 'Internet' ? "#FC876D" : "#ECB731",
                                                    fontSize: helpers.isDesktop() ? 19 : 13, lineHeight: helpers.isDesktop() ? 22.8 : 16, letterSpacing: helpers.isDesktop() ? 1 : 0.5,
                                                }, !helpers.isWeb() && { fontFamily: FontFamily.semiBold }, darkMode && { color: "#5263F4" }]}>
                                                    {item.category.name}
                                                </Text>
                                            </TouchableOpacityLink>
                                        </View>
                                        <CustomImage
                                            source={item?.featured_image?.sizes['thumb']}
                                            require={true}
                                            resizeMode={'cover'}
                                            style={{ marginTop: 10, width: "100%" }}
                                        />
                                        {!item.is_free && <PremiumTag />}
                                    </View>
                                    <View style={[{ maxWidth: helpers.isDesktop() ? "100%" : "100%" }]}>



                                        <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 30 : 16, lineHeight: helpers.isDesktop() ? 39 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { marginBottom: 15, fontFamily: FontFamily.abrilFatface }]}>
                                            {item.title}
                                        </Text>
                                        <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 27 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>
                                            {item.strapline}
                                        </Text>


                                        <View style={{ width: 100, height: 2, backgroundColor: "#907CFF", marginTop: 10, marginBottom: 10 }}></View>
                                        <View style={[Flex.row, Flex.alignCenter, { width: "100%", flexWrap: "wrap" }]}>
                                            <TouchableOpacityLink {...authorBtnClick}>

                                                <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                    <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                        <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                            <CustomImage
                                                                source={item.author[0].profile_image}
                                                                require={true}
                                                            />
                                                        </View>
                                                    </View>
                                                    <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>
                                                        {item.author[0].name}
                                                    </Text>


                                                </View>
                                            </TouchableOpacityLink>

                                            {seeSecondAuthor && item.author[1] &&
                                                <View style={[Flex.row, Flex.alignCenter, { marginRight: 15 }]}>
                                                    <View style={{ width: 40, height: 40, overflow: "hidden", marginRight: 10, borderRadius: 40, padding: 3, borderStyle: "solid", borderWidth: 1, borderColor: "#FC876D" }}>
                                                        <View style={{ width: 34, height: 34, overflow: "hidden", borderRadius: 36 }}>
                                                            <CustomImage
                                                                source={item.author[1].profile_image}
                                                                require={true}
                                                            />
                                                        </View>
                                                    </View>
                                                    <Text style={[{ fontWeight: '400', fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22 }, darkMode && { color: 'rgba(255,255,255,0.87)' }, { fontFamily: FontFamily.regular }]}>{item.author[1].name}</Text>
                                                </View>
                                            }
                                            {item.author.length > 1 && !seeSecondAuthor &&
                                                <TouchableOpacity onPress={() => this.setState({ seeSecondAuthor: true })}>
                                                    <View style={[{ borderStyle: "solid", fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19 : 22, borderWidth: 1, backgroundColor: "#F3F5FF", borderColor: "#907CFF", width: 28, height: 28, borderRadius: 28 }, Flex.alignCenter, Flex.row, Flex.justfiyCenter]}>+1</View>
                                                </TouchableOpacity>
                                            }
                                        </View>
                                        {/* </View> */}

                                        {/* </View>                 */}
                                    </View>
                                </TouchableOpacityLink>
                            </View>
                        )

                    })}
                </View>
            </View>
        );
    }
}

export default ArticleSpecificIndexStories;